<template>
  <div class="identifyImages" id="upLoadImage">
    <div class="main">
      <div class="top">
        <p>上传场景图片申请询价</p>
        <div class="isShowImg" v-if="imgKey" id="isShowImg">
          <recoghition-con v-if="imgKey" :imgData="imgKey" @errSearchImg="errSearchImg"></recoghition-con>
          <div class="innerIconspaecail innerIconspaecail-specail" v-if="progress !== 0">
            <div class="scrl-con" :style="{'top': (actualImageH/2-63) + 'px'}">
              <i-circle
                v-if="!error"
                :percent="progress"
                :size="126"
                trail-color="#A2A2A8"
                :trail-width="6"
                :stroke-width="6"
                stroke-color="#99C72C"
              >
                <span>智能识别中</span>
              </i-circle>
              <i-circle
                v-else
                :percent="progress"
                :size="126"
                trail-color="#E14B5D"
                :trail-width="6"
                :stroke-width="6"
                stroke-color="#99C72C"
              >
                <span>识别失败</span>
              </i-circle>
            </div>
          </div>
        </div>
        <div class="upLoadImage" v-else>
          <my-upload
            v-show="progress === 0"
            :format="['jpg','jpeg','png']"
            :maxSize="5120"
            :multiple="false"
            :type="1"
            @success="handleSuccess"
            @uploadError="handleUploadError"
            @formatError="handleFormatError"
            @maxSizeError="handleMaxSizeError"
            @progress="handleProgress"
            @errUpload="errUpload"
          ></my-upload>
          <div class="innerIcon" v-if="progress === 0 && !error">
            <i class="iconfont icon-uploadn"></i>
            <p>请先拖拽1张场景图片到此处或点击上传</p>
          </div>
          <div class="innerIconspaecail" v-if="progress > 0 && !error">
            <i-circle
              v-if="!error"
              :percent="progress"
              :size="126"
              trail-color="#A2A2A8"
              :trail-width="6"
              :stroke-width="6"
              stroke-color="#99C72C"
            >
              <span>智能识别中</span>
            </i-circle>
          </div>
          <div class="innerIconspaecail" v-if="error">
            <i-circle
              :percent="progress"
              :size="126"
              trail-color="#E14B5D"
              :trail-width="6"
              :stroke-width="6"
              stroke-color="#E14B5D"
            >
              <span>识别失败</span>
            </i-circle>
          </div>
        </div>
      </div>
      <div class="buttonUploadImg">
        <div class="uploadImg" id="uploadImg">
          <Tooltip
            v-if="(getData && getData.length === 0) || tipIsShow"
            :content="tipContent"
            placement="top"
            :always="true"
            style="position: absolute;left: 110px;top:-31px;z-index: 999;"
          ></Tooltip>
          <my-upload
            v-show="progress === 0"
            :format="['jpg','jpeg','png']"
            :maxSize="5120"
            :multiple="false"
            :type="1"
            @success="handleSuccess"
            @uploadError="handleUploadError"
            @formatError="handleFormatError"
            @maxSizeError="handleMaxSizeError"
            @progress="handleProgress"
            @errUpload="errUpload"
          ></my-upload>
          <div class="buttonUp">
            <i class="iconfont icon-plus"></i>
            <span>上传图片</span>
          </div>
        </div>
        <div class="uploadFolder" @click="folderHandle" v-if="isZhulogic">
          <i class="iconfont icon-Collectionfolder"></i>
          <span>从收藏夹选图</span>
        </div>
        <div class="uploadFolder-input">
          <input
            type="text"
            :disabled="progress > 0"
            v-model="pasteImgUrl"
            @keyup="upLoadImgPrease($event)"
            placeholder="此处粘贴图片地址（按Enter键确认）"
          >
        </div>
      </div>
      <div class="test" v-if="isZhulogic">
        <span></span>
        每款产品将花费4个恐龙蛋，价格有效期为3个月
      </div>

      <!--产品列表-->
      <offer-list @getList="getList"></offer-list>

      <!-- <div class="button">
                <button v-if="!submitButton" @click="submitHandle" :disabled="!getData || getData.length === 0 || !marquee.detailedListId">立即报价</button>
                <button class="button-specail" v-else>报价生成中...</button>
      </div>-->
    </div>
    <sel-fav-product ref="selFavProduct" @selfavImgHandle="selfavImgHandle"></sel-fav-product>
    <deduction-egg ref="deduction" @offerSubmit="offerSubmit"></deduction-egg>
    <egglack-box ref="egglack" :text="text" :type="dialogType"></egglack-box>
  </div>
</template>
<script>
import api from "../../../api";
import config from "../../../config/config";
import myUpload from "../../common/myUpload.vue";
import recoghitionCon from "./recognition.vue";
import offerList from "./offerlist.vue";
import selFavProduct from "../detailedLists/selFavProduct.vue";
import deductionEgg from "../../common/deductionEgg.vue";
import egglackBox from "../../common/eggLack.vue";

import ZhulogicMoudle from "../../../../../../zhulogic-module/packages/index.js";
const iCircle = ZhulogicMoudle.iCircle;

export default {
  data() {
    return {
      imgBaseUrl: api.common.imgBaseUrl,
      dialogType: 1,
      text: " 恐龙蛋余额不足，无法报价",
      tipContent: "未识别到家具，请您使用自定义框图",
      tipIsShow: false,
      progress: 0,
      error: false,
      imgKey: null,
      imgHeight: null,
      getImgConData: 0,
      pasteImgUrl: null,
      submitButton: false,
      marquee: {
        detailedListId: 0,
        quoteProducts: [],
        originFile: {}
      },
      actualImageW: null,
      actualImageH: null,
      isConnet: false,
      array: [],
      isZhulogic: config.isZhulogic,
      imgId: null,
      imgUrlId: null
    };
  },
  computed: {
    getData() {
      return this.$store.state.app.identtificationData;
    }
  },
  components: {
    myUpload,
    recoghitionCon,
    offerList,
    selFavProduct,
    deductionEgg,
    egglackBox,
    iCircle
  },
  methods: {
    balance() {
      return this.$store.state.app.balance;
    },
    getImgConHeight() {
      this.$nextTick(() => {
        let d = document.getElementById("isShowImg");
        this.getImgConData = d.offsetHeight / 2;
      });
    },
    errUpload() {
      this.error = true;
      this.progress = 0;
    },
    handleSuccess(value) {
      this.marquee.originFile = value.data[0];
      this.judgementWidth(value.data[0].width, value.data[0].height);
      if (!this.tipIsShow) {
        this.imgKey = value.data[0];
        this.imgHeight = value.data[0].height;
        this.getImgConHeight();
        this.pasteImgUrl = null;
        this.progress = 0;
      }
    },
    handleUploadError() {
      this.error = true;
      this.$Message.error("上传失败,请重新上传");
      this.progress = 0;
    },
    handleFormatError() {
      this.$Message.error("请选择 jpg,jpeg 或 png 格式的文件");
    },
    handleMaxSizeError() {
      this.$Message.error("请选择小于 5M 的图片");
    },
    handleProgress(progress) {
      this.error = false;
      this.progress = progress;
    },
    errSearchImg() {
      //图片识别失败处理
      this.imgKey = null;
      this.error = true;
      this.progress = 99;
    },
    getList(id) {
      this.marquee.detailedListId = id;
    },

    //从收藏夹选图
    folderHandle() {
      if (this.progress > 0) {
        return;
      }
      this.$refs.selFavProduct.open(0, "type");
    },

    upLoadImgPrease(e) {
      if (e.keyCode == 13) {
        if (!this.pasteImgUrl) {
          this.$Message.error("请粘贴图片地址！");
          return;
        }
        this.urlUploadImg(this.pasteImgUrl);
      }
    },
    selfavImgHandle(key, id) {
      this.imgId = id;
      //获得从收藏件得到图片key
      this.urlUploadImg(this.imgBaseUrl + key);
    },

    getUrlImg() {
      this.imgUrlId = this.$route.query.imgUrlId;
      let key = this.$route.query.key;
      this.urlUploadImg(this.imgBaseUrl + key);
    },

    urlUploadImg(url) {
      this.error = false;
      this.timer = window.setInterval(() => {
        this.progress += 5;
      }, 200);
      let object = {
        url: url
      };
      api.imgSearch.uploadProductImageByUrl(object).then(res => {
        this.judgementWidth(res.width, res.height);
        if (!this.tipIsShow) {
          if (!res.key) {
            this.progress = 0;
            this.$Message.error("图片上传错误，请重新上传！");
            window.clearInterval(this.timer);
            return;
          }
          this.marquee.originFile = {
            id: res.id
          };
          this.imgKey = res;
          this.imgHeight = res.height;
          this.getImgConHeight();
          window.clearInterval(this.timer);
          this.pasteImgUrl = null;
          this.progress = 0;
        }
      });
    },

    //立即报价
    submitHandle() {
      this.array = [];
      //获得所有url的集合
      this.marquee.quoteProducts = [];
      let obj = {};
      this.isConnet = true;
      let ix = this.imgKey.width / this.actualImageW;
      let iy = this.imgKey.height / this.actualImageH;
      this.getData &&
        this.getData.forEach(item => {
          if (!item.material || !item.name || !item.sku) {
            this.$Message.error("请您完善 产品名/规格/材质 等必填项！");
            isConnet = false;
            this.submitButton = false;
            return;
          }
          let url =
            this.imgBaseUrl +
            item.imgKey +
            "?x-oss-process=image/crop,x_" +
            parseInt(item.pw * ix) +
            ",y_" +
            parseInt(item.ph * iy) +
            ",w_" +
            parseInt(item.w * ix) +
            ",h_" +
            parseInt(item.h * iy);
          obj = {
            material: item.material,
            name: item.name,
            remark: "",
            size: item.sku,
            partFiles: []
          };
          this.array.push(url);
          this.marquee.quoteProducts.push(obj);
        });

      if (!this.isZhulogic) {
        return this.offerSubmit();
      }

      //提示恐龙蛋
      let needBalance = parseInt(this.getData.length * 4);
      if (needBalance <= this.balance()) {
        this.$refs.deduction.open("offer", needBalance);
      } else {
        this.$refs.egglack.open();
      }
    },

    offerSubmit() {
      this.$refs.deduction.cancel();
      this.submitButton = true;
      if (this.imgId) {
        this.marquee.originFile = {
          id: this.imgId
        };
      }
      if (this.imgUrlId) {
        this.marquee.originFile = {
          id: this.imgUrlId
        };
      }
      //根据url上传请求获得file
      if (this.isConnet) {
        api.imgSearch.uploadProductImageByUrlList(this.array).then(res => {
          //处理数组
          res &&
            res.forEach((v, index) => {
              this.marquee.quoteProducts[index].partFiles.push(v);
            });
          //请求报价
          api.imgSearch
            .batch_quote(this.marquee)
            .then(res => {
              this.$Message.success("报价成功！");
              this.submitButton = false;
              if (res) {
                this.$router.push({
                  name: "mySuccessQuoting",
                  params: { id: res }
                });
              } else {
                this.Message.error("报价失败");
              }
            })
            .catch(err => {
              this.submitButton = false;
            });
        });
      }
    },
    //判断图片是不是小于300px
    judgementWidth(width, height) {
      this.tipIsShow = false;
      if (width <= 300 || height <= 300) {
        this.tipIsShow = true;
        this.tipContent = "上传失败，图片宽高应该大于300！";
        this.progress = 0;
        window.clearInterval(this.timer);
        return false;
      }
    }
  },
  destroyed() {
    //重置数据
    this.$store.dispatch("getIdenttification", null);
  },
  watch: {
    imgKey: function() {
      this.actualImageW =
        (this.imgKey.height / this.imgKey.width) * 1130 <= 1000
          ? 1130
          : (this.imgKey.width / this.imgKey.height) * 1000;
      this.actualImageH =
        (this.imgKey.height / this.imgKey.width) * 1130 <= 1000
          ? 1130 / (this.imgKey.width / this.imgKey.height)
          : 1000;
    },
    getData: function() {
      this.tipContent = "未识别到家具，请您使用自定义框图";
    }
  },
  created() {
    if (this.$route.query.key) {
      this.getUrlImg();
    }
    this.$store.dispatch("getBalance");
  }
};
</script>
<style>
#uploadImg .ivu-tooltip-inner {
  color: #e14b5d;
  background: #fff;
  border: 1px solid #e14b5d;
}
#uploadImg .ivu-tooltip-popper .ivu-tooltip-arrow {
  border-top-color: rgba(225, 75, 93, 0.9);
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped type="text/scss">
.identifyImages {
  width: 100%;
  background: #fff;
  padding-top: 33px;
  padding-bottom: 45px;
  .main {
    width: 1130px;
    margin: 0px auto;
    .top {
      p {
        font-size: 24px;
        color: #353838;
        margin-bottom: 19px;
      }
      .isShowImg {
        width: 100%;
        text-align: center;
        position: relative;
        font-size: 0px;
        .innerIconspaecail {
          background: rgba(108, 111, 112, 0.7);
          padding: 20px;
          display: inline-block;
          position: absolute;
          left: 495px;
          z-index: 10;
          .ivu-chart-circle-inner {
            span {
              color: #fff;
            }
          }
        }
        .innerIconspaecail-specail {
          width: 100%;
          height: 100%;
          left: 0px;
          top: 0px;
          text-align: center;
          z-index: 999;
          .scrl-con {
            position: absolute;
            display: inline-block;
            margin-left: -35px;
          }
        }
      }
      .upLoadImage {
        width: 100%;
        height: 420px;
        text-align: center;
        cursor: pointer;
        position: relative;
        background: rgba(247, 247, 247, 1);
        .innerIcon {
          display: inline-block;
          position: absolute;
          top: 0;
          left: 390px;
          z-index: 10;
          i {
            display: inline-block;
            color: #c3c3c3;
            font-size: 73px;
            margin-top: 115px;
          }
          p {
            font-size: 20px;
            color: #353838;
            margin-top: 34px;
          }
        }
        .innerIconspaecail {
          display: inline-block;
          position: absolute;
          top: 150px;
          left: 495px;
          z-index: 10;
        }
      }
    }

    .buttonUploadImg {
      width: 100%;
      height: 60px;
      position: relative;
      display: flex;
      .uploadImg,
      .uploadFolder {
        width: 216px;
        height: 100%;
        background: #313131;
        line-height: 55px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
        float: left;
        i {
          font-size: 22px;
        }
        span {
          font-size: 20px;
          margin-left: 8px;
        }
      }
      .uploadFolder-input {
        display: inline-block;
        flex: 1;
        height: 60px;
        background: #ebeff0;
        input {
          width: 100%;
          height: 100%;
          padding-left: 19px;
          font-size: 20px;
          color: #6c6f70;
          background: #ebeff0;
        }
      }
      .uploadImg {
        .buttonUp {
          position: absolute;
          width: 216px;
          height: 60px;
          line-height: 60px;
          z-index: 9;
          top: 0;
          left: 0px;
        }
      }
      .uploadFolder {
        background: #fff;
        color: #313131;
        border: 1px solid #313131;
        i {
          font-size: 26px;
        }
      }
      .uploadImg:hover {
        opacity: 0.8;
      }
      .uploadFolder:hover {
        opacity: 0.8;
      }
    }
    .test {
      font-size: 14px;
      color: #353838;
      margin-top: 15px;
      span {
        display: inline-block;
        width: 12px;
        height: 12px;
        background: #e14b5d;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 12px;
        margin-top: -3px;
      }
    }
    .button {
      margin-top: 28px;
      text-align: center;
      button {
        width: 317px;
        height: 50px;
        border-radius: 0px;
        background: #e14b5d;
        color: #fff;
        &:hover {
          opacity: 0.8;
        }
        &:disabled {
          background: #c8cccc;
          cursor: default;
          color: #fff;
        }
      }
      .button-specail {
        background: #c8cccc;
        cursor: default;
      }
      p {
        width: 317px;
        text-align: left;
        font-size: 14px;
        color: #e14b5d;
        margin: 0 auto;
      }
    }
  }
}
</style>

<style>
#upLoadImage .upload {
  position: relative;
  z-index: 99;
  width: 100%;
  height: 100%;
  opacity: 0;
}

#upLoadImage .ivu-upload {
  height: 100%;
}

#upLoadImage .ivu-upload-select {
  width: 100%;
  height: 100%;
}
</style>
